var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { connect } from "formik";
import { DropdownField } from "@ane/ui-components/lib/components/FormikFormFields/DropdownField";
import { Dialog, ButtonDialogType, FormActions, PrimaryButton, DefaultButton } from "@ane/ui-components";
import { SpecialColumnsComponentConstants } from "../../../../constants/DataSource.constants.js";
import { useState } from "react";
import { useSelector } from "react-redux";
function SpecialColumnsDropdown(props) {
  var _a, _b, _c;
  const { formik, index, dropdownProps = {}, fieldName } = props;
  const flightFormats = useSelector((state) => state.dataSourceManagementModule.dataSourceFlightFormats.items.data);
  const { setFieldValue, values } = formik;
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const currentValue = (_c = (_b = (_a = values.flightList) == null ? void 0 : _a[index]) == null ? void 0 : _b.Example) != null ? _c : "";
  const [originalValue, setOriginalValue] = useState([]);
  const [newValue, setNewValue] = useState([]);
  const _onChange = (ev, option) => {
    if (!(option == null ? void 0 : option.data)) {
      return;
    }
    const newList = [...values.flightList];
    newList[index] = __spreadProps(__spreadValues({}, newList[index]), {
      Format: option.data.Example,
      Example: option.data.Example,
      Source: option.data.Source,
      Definition: option.data.Definition
    });
    if (!(flightFormats == null ? void 0 : flightFormats.map((item) => item.Example).includes(currentValue)) && currentValue !== "") {
      setShowConfirmDialog(true);
      setOriginalValue(values.flightList);
      setNewValue(newList);
    } else {
      setFieldValue == null ? void 0 : setFieldValue(`flightList`, newList);
    }
  };
  const _onDismissDialog = () => {
    setShowConfirmDialog(false);
    setFieldValue == null ? void 0 : setFieldValue("flightList", originalValue);
  };
  const _onConfirmDialog = () => {
    setShowConfirmDialog(false);
    setFieldValue == null ? void 0 : setFieldValue("flightList", newValue);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DropdownField,
      __spreadProps(__spreadValues({}, dropdownProps), {
        name: fieldName,
        ariaLabel: `Select flight format-${props.index}`,
        options: props.formatOptions,
        description: "Select format",
        onChange: _onChange
      })
    ),
    /* @__PURE__ */ jsxs(
      Dialog,
      {
        hidden: !showConfirmDialog,
        dialogContentProps: {
          title: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.title,
          type: ButtonDialogType.normal
        },
        maxWidth: 600,
        minWidth: 500,
        modalProps: {
          isBlocking: false
        },
        onRenderFooter: () => /* @__PURE__ */ jsxs(FormActions, { children: [
          /* @__PURE__ */ jsx(
            PrimaryButton,
            {
              ariaLabel: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.confirmBtn.ariaLabel,
              onClick: _onConfirmDialog,
              text: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.confirmBtn.label
            }
          ),
          /* @__PURE__ */ jsx(
            DefaultButton,
            {
              ariaLabel: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.cancelBtn.ariaLabel,
              onClick: _onDismissDialog,
              text: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.cancelBtn.ariaLabel
            }
          )
        ] }),
        children: [
          SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.subText,
          /* @__PURE__ */ jsx("br", {}),
          "(You will not be able to revert back to ",
          /* @__PURE__ */ jsx("b", { children: currentValue }),
          ". Click cancel to keep the format unchanged."
        ]
      }
    )
  ] });
}
const SpecialColumnsDropdown$1 = connect(SpecialColumnsDropdown);
export {
  SpecialColumnsDropdown,
  SpecialColumnsDropdown$1 as default
};
//# sourceMappingURL=SpecialColumnsDropdown.js.map
